<template>
  <div class="row">
    <!-- 标题-副标题 -->
    <div class="col-md-12">
      <h4 class="title">{{title}}</h4>
      <p class="category">{{category}}</p>
    </div>
    <!--    <Search v-bind:list="searchOption" @getData="searchData"></Search>-->
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">{{categorySecond}}</div>
      </div>

      <div class="card-body row">
        <!-- 分页 -->
        <div class="col-sm-6">
          <el-select
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          &nbsp;
          <p-button type="success" @click="cractAccount">
            <i slot="label" class="nc-icon nc-check-2"></i>
            新建用户
          </p-button>
        </div>

        <!-- 搜索 -->
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input class="input-sm"
                      placeholder="搜索"
                      v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>

        <!-- 表格 -->
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    :data="queriedData"
                    border
                    style="width: 100%">

            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
            <el-table-column
              :min-width="120"
              fixed="right"
              class-name="td-actions"
              label="操作">
              <template slot-scope="props">
                <!--                <el-button-->
                <!--                  size="small"-->
                <!--                  type="default"-->
                <!--                  icon="edit"-->
                <!--                  @click="handleEdit(props.$index, props.row)">编辑-->
                <!--                </el-button>-->
                <el-button
                  size="small"
                  type="info"
                  icon="setting"
                  @click="handleRoleConfig(props.$index, props.row)">配置角色
                </el-button>
                <el-button
                  size="small"
                  type="info"
                  icon="setting"
                  @click="initializePassword(props.$index, props.row)">密码初始化
                </el-button>
                <el-button
                  size="small"
                  type="danger"
                  @click="handleDelete(props.$index, props.row)">删除
                </el-button>
                <!--                <p-button type="danger" size="sm" icon @click="handleDelete(props.$index, props.row)">-->
                <!--                  <i class="fa fa-times"></i>-->
                <!--                </p-button>-->
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 底部 -->
        <div class="col-sm-6 pagination-info">
          <p class="category">{{page}}</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增用户" :visible.sync="dialogFormVisible">
      <fg-input v-model="formUsername" placeholder="请输入登录账号" label="账号"></fg-input>
      <fg-input v-model="formName" placeholder="请输入昵称" label="用户名"></fg-input>
      <div slot="footer" class="dialog-footer">
        <div class="btn-group">
          <p-button type="info" round outline v-on:click="dialogFormVisible=false">取 消</p-button>
          <p-button type="info" round @click="cractAccountSubmit">确 定</p-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="权限配置" :visible.sync="dialogroleVisible" width="640px">
      <el-transfer v-model="dialogValue" :data="dialogData" :titles="['角色列表', '拥有角色']" :filterable="true"></el-transfer>
      <div slot="footer" class="dialog-footer">
        <div class="btn-group">
          <p-button type="info" round outline @click="dialogroleVisible=false">取 消</p-button>
          <p-button type="info" round @click="dialogRoleSubmit">确 定</p-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import {Table, TableColumn, Select, Option, Dialog} from 'element-ui'
    import Search from 'src/components/UIComponents/Search/Search.vue'
    import PPagination from 'src/components/UIComponents/Pagination.vue'
    import {getFetch} from 'src/util/fetch'
    import {getchanels} from "../../../../util/getchanels";
    import {getCheck} from "../../../../util/getCheck";

    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Dialog)
    export default {
        components: {
            PPagination,
            Search,
        },
        computed: {
            pagedData() {
                return this.tableData.slice(this.from, this.to)
            },
            queriedData() {
                if (!this.searchQuery) {
                    this.changeTotal(this.tableData.length)
                    return this.pagedData
                }
                let result = this.tableData
                    .filter((row) => {
                        let isIncluded = false
                        for (let key of this.propsToSearch) {
                            let rowValue = row[key].toString()
                            if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                                isIncluded = true
                            }
                        }
                        return isIncluded
                    })
                this.changeTotal(result.length)
                return result.slice(this.from, this.to)
            },
            to() {
                let highBound = this.from + this.pagination.perPage
                if (this.total < highBound) {
                    highBound = this.total
                }
                return highBound
            },
            from() {
                return this.pagination.perPage * (this.pagination.currentPage - 1)
            },
            total() {
                this.changeTotal(this.tableData.length)
                return this.tableData.length
            },
            page() {
                return `显示 ${this.from + 1} to ${this.to} of ${this.total}`
            }
        },
        data() {//定义tabel
            return {
                dialogValue: [],
                dialogData: [],
                title: '用户列表',
                category: "",
                categorySecond: '用户列表',
                userrole: "",//用户角色
                currentRow: {},//当前行
                dialogroleVisible: false,
                dialogFormVisible: false,
                pagination: {//分页
                    perPage: 10,
                    currentPage: 1,
                    perPageOptions: [5, 10, 25, 50],
                    total: 0
                },
                formUsername: '',
                formName: '',
                searchQuery: '',//搜索值
                propsToSearch: ['id', 'name', 'username'],//搜索字段
                tableColumns: [//列表
                    {
                        prop: 'id',
                        label: '用户id',
                        minWidth: 100,
                    },
                    {
                        prop: 'username',
                        label: '账号',
                        minWidth: 100,
                    },
                    {
                        prop: 'name',
                        label: '用户名',
                        minWidth: 100,
                    },
                ],
                tableData: [],//渲染table数据
                searchOption: [
                    {
                        key: 'username',
                        label: '用户名',
                        type: 'text',
                    },
                    {
                        key: 'startTime',
                        label: '开始时间',
                        type: 'datetime',
                    },
                    {
                        key: 'endDate',
                        label: '结束日期',
                        type: 'date',
                    }
                ]
            }
        },
        methods: {
            async dialogRoleSubmit() {
                let opt = {
                    url: '/api/users/grant/',
                    type: 'POST',
                    data: {
                        uid: this.currentRow.id,
                        rid: this.dialogValue,
                    }
                }
                // console.log(this.dialogValue)
                const res = await getFetch(this, opt);
                if (res.code == 0) {
                    this.dialogroleVisible = false
                    this.getData();
                    swal({
                        title: '操作成功!',
                        type: 'success',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        buttonsStyling: false
                    })
                }
            },
            async initializePassword(index,row){
              this.currentRow = row;
              let opt = {
                url: '/api/users/user/',
                type: 'PUT',
                data: {
                  uid: this.currentRow.id
                }
              }

              const res = await getFetch(this, opt);
              if (res.code == 0) {
                  alert("密码初始化成功")
              }
            },
            async handleRoleConfig(index, row) {
                this.currentRow = row;
                this.dialogroleVisible = true;
                this.dialogValue = [];
                let opt = {
                    url: '/api/users/grant/',
                    type: 'GET',
                    data: {
                        uid: this.currentRow.id
                    }
                }
                const res = await getFetch(this, opt);
                if (res.code == 0) {
                    // console.log(res.data.roles)
                    for (let i = 0; i < res.data.roles.length; i++) {
                        if (res.data.roles[i]) {
                            this.dialogValue.push(res.data.roles[i].id)
                            // this.dialogValue.push({
                            //    key: res.data[i].id,
                            //     label: res.data[i].rtitle,
                            // })
                        }
                    }

                }

            },
            async getAllRoleList() {
                let opt = {
                    url: '/api/users/role/',
                    type: 'GET',
                    data: {
                        size: 10000,
                    }
                }
                const res = await getFetch(this, opt);
                if (res.code == 0) {
                    for (let i in res.data.roles.results) {
                        this.dialogData.push({
                            key: res.data.roles.results[i].id,
                            label: res.data.roles.results[i].rtitle,
                        });
                    }
                }
            },
            // searchData(data) {
            //     alert(JSON.stringify(data))
            // },
            cractAccount() {
                this.dialogFormVisible = true
            },
            async cractAccountSubmit() {
                let opt = {
                    url: '/api/users/user/',
                    type: 'POST',
                    data: {
                        username: this.formUsername,
                        password: '9377!@#',
                        name: this.formName
                    }
                }
                const res = await getFetch(this, opt);
                if (res.code == 0) {
                    this.dialogFormVisible = false
                    this.getData()
                    // this.tableData = res.data.user
                    this.cleanData()
                }
            },
            cleanData() {
                this.formName = ''
                this.formUsername = ''
            },
            changeTotal(length) {
                this.pagination.total = length
            },

            async handleDelete(index, row) {
                swal({
                    title: '确定要删除帐号？',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    buttonsStyling: false
                }).then(() => {
                    this.doDelete(index, row)
                })
            },
            async doDelete(index, row) {
                let opt = {
                    url: '/api/users/user/',
                    type: 'delete',
                    data: {
                        uid: row.id
                    }
                }
                const res = await getFetch(this, opt);
                if (res.code == 0) {
                    swal({
                        title: '删除成功!',
                        type: 'success',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        buttonsStyling: false
                    })

                    this.getData()
                }
            },
            async getData() {
                let opt = {
                    url: '/api/users/user/',
                    type: 'GET',
                    //  如果需要接入第三方的接口，需要添加此参数
                    // host:window.Config.homeHost
                }
                const res = await getFetch(this, opt);
                if (res.code == 0) {
                    this.tableData = res.data.user
                }
            },

        },
        mounted() {
            this.getData();
            this.getAllRoleList()
        }
    }
</script>
